<template>
  <div class="dashboard-home">
    <div v-if="visibleTabs.length > 0" class="dashboard-tabs">
      <button
        v-for="tab in visibleTabs"
        :key="tab.key"
        type="button"
        class="dashboard-tab"
        :class="{ 'is-active': activeTab === tab.key }"
        @click="activeTab = tab.key"
      >
        {{ tab.label }}
      </button>
    </div>

    <div v-if="visibleTabs.length === 0" class="dashboard-placeholder">
      <div class="placeholder-inner">
        <app-icon icon="el-icon-document" />
        <p class="placeholder-title">暂无首页查看权限</p>
        <p class="placeholder-desc">请联系管理员分配首页概况页签权限</p>
      </div>
    </div>
    <template v-else>
      <dashboard-lease-overview v-if="activeTab === 'lease'" />
      <dashboard-performance-overview v-else-if="activeTab === 'performance'" />
      <dashboard-dealer-overview v-else-if="activeTab === 'dealer'" />
      <dashboard-user-overview v-else-if="activeTab === 'user'" />
      <dashboard-core-overview v-else-if="activeTab === 'core'" />
      <dashboard-after-sales-overview v-else-if="activeTab === 'afterSales'" />

      <div v-else class="dashboard-placeholder">
        <div class="placeholder-inner">
          <app-icon icon="el-icon-document" />
          <p class="placeholder-title">{{ currentTabLabel }}</p>
          <p class="placeholder-desc">内容开发中，敬请期待</p>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import DashboardLeaseOverview from './dashboard/DashboardLeaseOverview.vue'
import DashboardPerformanceOverview from './dashboard/DashboardPerformanceOverview.vue'
import DashboardDealerOverview from './dashboard/DashboardDealerOverview.vue'
import DashboardUserOverview from './dashboard/DashboardUserOverview.vue'
import DashboardCoreOverview from './dashboard/DashboardCoreOverview.vue'
import DashboardAfterSalesOverview from './dashboard/DashboardAfterSalesOverview.vue'
import { DASHBOARD_HOME_TABS } from './dashboard/dashboardLeaseMock'
import { canViewDashboardTab, getFirstAccessibleDashboardTab } from '@/utils/permissionMap'

export default {
  name: 'DashboardPage',
  components: {
    DashboardLeaseOverview,
    DashboardPerformanceOverview,
    DashboardDealerOverview,
    DashboardUserOverview,
    DashboardCoreOverview,
    DashboardAfterSalesOverview,
  },
  data() {
    return {
      tabs: DASHBOARD_HOME_TABS,
      activeTab: 'lease',
    }
  },
  computed: {
    visibleTabs() {
      return this.tabs.filter(t => canViewDashboardTab(t.key))
    },
    currentTabLabel() {
      const t = this.tabs.find(x => x.key === this.activeTab)
      return t ? t.label : ''
    },
  },
  created() {
    this.fixActiveTab()
  },
  watch: {
    visibleTabs() {
      this.fixActiveTab()
    },
  },
  methods: {
    fixActiveTab() {
      if (!canViewDashboardTab(this.activeTab)) {
        this.activeTab = getFirstAccessibleDashboardTab(this.tabs)
      }
    },
  },
}
</script>

<style scoped>
.dashboard-home {
  width: 100%;
  max-width: 100%;
  min-height: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
  background: #f0f2f5;
}

.dashboard-tabs {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0;
  margin-bottom: 0;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 4px 4px 0 0;
  padding: 0 4px;
  border-bottom: none;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.dashboard-tab {
  position: relative;
  padding: 14px 20px;
  border: none;
  background: transparent;
  font-size: 14px;
  color: #595959;
  cursor: pointer;
  transition: color 0.2s;
  white-space: nowrap;
}

.dashboard-tab:hover {
  color: #1890ff;
}

.dashboard-tab.is-active {
  color: #1890ff;
  font-weight: 500;
}

.dashboard-tab.is-active::after {
  content: '';
  position: absolute;
  left: 12px;
  right: 12px;
  bottom: 0;
  height: 2px;
  background: #1890ff;
  border-radius: 1px 1px 0 0;
}

.dashboard-placeholder {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 0 0 4px 4px;
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.placeholder-inner {
  text-align: center;
  color: #bfbfbf;
}

.placeholder-inner .el-icon-document {
  font-size: 48px;
  margin-bottom: 16px;
}

.placeholder-title {
  margin: 0 0 8px;
  font-size: 16px;
  color: #8c8c8c;
  font-weight: 500;
}

.placeholder-desc {
  margin: 0;
  font-size: 14px;
  color: #bfbfbf;
}

.dashboard-home :deep(.lease-overview), .dashboard-home :deep(.perf-overview), .dashboard-home :deep(.dealer-overview), .dashboard-home :deep(.user-overview), .dashboard-home :deep(.core-overview), .dashboard-home :deep(.after-sales-overview) {
  border: 1px solid #e8e8e8;
  border-radius: 0 0 4px 4px;
  padding: 12px;
  background: #f0f2f5;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
}

</style>
